module.exports = __webpack_public_path__ + "img/Untitled_Artwork.2de2b7d9.png";